import {ProcedureFilter} from './procedure-filter';

export class ProcedureListRequest {
  search: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;
  filter: ProcedureFilter;

  constructor(search: string, limit: number, offset: number,
              sortProp: string, sortDir: string, filter: ProcedureFilter) {
    this.search = search;
    this.limit = limit;
    this.offset = offset;
    this.sortProp = sortProp;
    this.sortDir = sortDir;
    this.filter = filter;
  }
}
